import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { RiDoorLine } from 'react-icons/ri'

import Loader from 'react-loaders'
import useMediaQuery from '../../../../CustomHook/useMediaQuery'
import { primary_color } from '../../../../Helper/uiHelper'
import { setNotification } from '../../../../Redux/Reducers/notificationHandling'
import { request } from '../../../../Redux/Sagas/requests/api'

const normalizeQuestions = (rawQuestions) => {
  if (Array.isArray(rawQuestions)) return rawQuestions
  if (Array.isArray(rawQuestions?.data)) return rawQuestions.data
  return []
}

const Lockers = ({ data, formFieldValue = {}, currentLockerData, unitData, dependent_value, newLockerData, setNewData, formData, setFormData }) => {
  const dispatch = useDispatch()
  const isDesktop = useMediaQuery('(min-width:768px)')

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const payment_id = searchParams.get('payment_id')

  const [selectedLocker, setSelectedLocker] = useState()
  const [lockers, setLockers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [questions, setQuestions] = useState([])
  const lockerColWidth = isDesktop ? 131.3 : 99.2
  const [lockerColCount, setLocakerCoCount] = useState(0)

  //* Convert API Data into vertical Array
  const displayVertically = (arr, rowCount) => {
    const output = arr.reduce((rows, item, index) => {
      const rowIndex = index % rowCount
      rows[rowIndex] = rows[rowIndex] || []
      rows[rowIndex].push(item)
      return rows
    }, [])

    return output
  }

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const payload = {
        field_data: 'items.locations',
        source_field: 'location_id',
        depend_field_value: dependent_value,
      }
      if (formData?.[0]?.item_date_time_id) {
        payload.item_date_time_id = formData[0].item_date_time_id
      }
      const response = await request('get-template-data-depend', 'POST', payload)
      if (response?.status === 200 || response?.status === 202) {
        const formattedData = displayVertically(response?.data?.data, response?.data?.lockerHeight)
        const apiQuestions = normalizeQuestions(response?.data?.questions)
        const new_lockers = formattedData?.map((item) => {
          return item?.map((dataItem) => {
            return {
              id: dataItem?.id,
              reserved: dataItem?.completed || dataItem?.reserved ? true : false,
              display: dataItem?.display,
              item_name: dataItem?.name,
              price: dataItem?.rate,
              questions: normalizeQuestions(dataItem?.questions).length ? normalizeQuestions(dataItem?.questions) : apiQuestions,
              total_cost: `${dataItem?.rate}`,
            }
          })
        })
        setLocakerCoCount(formattedData[0]?.length)
        setLockers(new_lockers)
        const mappedId = response?.data?.mapped_location_id
        if (mappedId && String(mappedId) !== String(formData?.[0]?.location_id) && setFormData) {
          setFormData((prev) =>
            (prev || []).map((row, i) => {
              if (i !== 0) return row
              return {
                ...row,
                location_id: mappedId,
                location_id_label: response.data.mapped_location_name || row.location_id_label,
              }
            })
          )
        }
      }
    } catch (e) {
      console.error('Error in get-template-data-depend : ', e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!dependent_value) {
      setLockers([])
      return
    }
    fetchData()
  }, [dependent_value, formData?.[0]?.item_date_time_id])

  const onChangeValue = (reserved, value, item) => {
    if (reserved && !unitData.map((e) => e.item_id).includes(item?.id))
      return dispatch(
        setNotification({
          type: 'error',
          message: 'This locker is already reserved.',
        })
      )

    let itemToCheck = {
      ...item,
    }
    if (formData?.[0]) {
      itemToCheck = {
        ...itemToCheck,
        item_date_time_id: formData?.[0]?.item_date_time_id,
        location_id: formData?.[0]?.location_id,
        category_id: formData?.[0]?.category_id,
      }
    }

    let payload = {
      items: [itemToCheck],
      is_move_booking: true,
      // items: [item?.id],
    }
    request('check-item-availability', 'POST', payload).then((res) => {
      if (res.status === 200 || res?.status === 202) {
        setSelectedLocker(value)

        setNewData((old) => {
          const selectedQuestions = normalizeQuestions(item?.questions)
          return {
            ...old,
            item_id: item?.id,
            item_id_label: item?.name || item?.item_name,
            total_cost: item?.total_cost ?? item?.price ?? old?.total_cost,
            questions: selectedQuestions.length ? selectedQuestions : old?.questions,
            location_id: formData?.[0]?.location_id || old?.location_id,
            location_id_label: formData?.[0]?.location_id_label || old?.location_id_label,
            item_date_time_id: formData?.[0]?.item_date_time_id || old?.item_date_time_id,
            item_date_time_id_label: formData?.[0]?.item_date_time_id_label || old?.item_date_time_id_label,
            category_id: formData?.[0]?.category_id || old?.category_id,
            reservation_id: old?.reservation_id,
          }
        })
        // setFormFieldValue({...updatedValue , questions : createDefaultAnswersNew(item?.questions)})
      } else {
        dispatch(
          setNotification({
            type: 'error',
            message: res?.data?.message,
          })
        )
        fetchData()
      }
    })
  }
  const getBgColor = (item) => {
    if (newLockerData?.item_id === item?.id) {
      return '#06880BCC'
    } else if (currentLockerData?.item_id === item?.id) {
      return '#059669CC'
    } else if (item?.display === 0) {
      return '#FFFFFF'
    } else if (item?.reserved) {
      return '#F87171'
    } else {
      return primary_color
    }
  }

  if (isLoading)
    return (
      <div className='d-flex align-items-center justify-content-center' style={{ height: '10rem' }}>
        <Loader type='ball-pulse' color={primary_color} />
      </div>
    )
  if (!lockers.length && dependent_value)
    return (
      <div className='d-flex align-items-center justify-content-center' style={{ height: '10rem' }}>
        No lockers found.
      </div>
    )
 
  return (
    <div className='mt-2'>
      {lockers?.length ? (
        <div className='d-flex align-items-center mb-5 mt-5 subtitle1'>
          <div className='rounded-pill mr-2 subtitle1' style={{ height: '1rem', width: '1rem', background: '#059669CC' }}></div> Currently Booked
          <div className='rounded-pill mr-2 ml-3 subtitle1' style={{ height: '1rem', width: '1rem', background: primary_color }}></div> Available
          <div className='rounded-pill mr-2 ml-3 subtitle1' style={{ height: '1rem', width: '1rem', background: '#06880BCC' }}></div> Booked
          <div className='rounded-pill mr-2 ml-3 subtitle1' style={{ height: '1rem', width: '1rem', background: '#F87171' }}></div> Not Available
        </div>
      ) : (
        <></>
      )}
      <div className=' mb-2 !w-100 custom-scrollbar' style={{ overflow: 'auto' }}>
        <div style={{ width: lockerColWidth * lockerColCount + 'px' }} className='d-flex flex-wrap'>
          {lockers?.map((locakerItem, index) => {
            return locakerItem?.map((item, i) => {
              const isDisplayZero = item?.display === 0 ? true : false
              return (
                <div
                  key={'lockers' + index + i}
                  onClick={() => {
                    if (!item?.display) return
                    onChangeValue(item?.reserved, item?.id, item)
                  }}
                  className=' position-relative'
                  style={{
                    width: isDesktop ? '8rem' : '6rem',
                    margin: '0.1rem',
                    height: isDesktop ? '10rem' : '9rem',
                    background: getBgColor(item),
                    cursor: !item?.reserved || !isDisplayZero ? 'pointer' : 'default',
                  }}>
                  {!isDisplayZero ? (
                    <div
                      className='m-1 position-absolute subtitle1'
                      style={{
                        left: '0.5rem',
                        top: '0.25rem',
                        background: 'white',
                        padding: '0rem 0.5rem',
                        borderRadius: '14px',
                        fontWeight: '500',
                      }}>
                      <div>£{item?.price}</div>
                    </div>
                  ) : null}
                  {!!item?.display && (
                    <div className='position-absolute' style={{ top: '50%', left: '50%', transform: 'translate(-50% , -50%)' }}>
                      {/* <i class='fa-thin fa-door-closed' style={{ fontSize: '5rem' }}></i> */}
                      <RiDoorLine style={{ color: '#DADADA', fontSize: '6rem' }} />
                    </div>
                  )}

                  <div
                    className='text-align-center mt-2 subtitle1'
                    style={{
                      color: '#EDF0F7',
                      position: 'absolute',
                      bottom: '1rem',
                      fontWeight: '500',
                      left: '50%',
                      transform: 'translate(-50%)',
                    }}>
                    {item?.item_name}
                  </div>
                </div>
              )
            })
          })}
        </div>
      </div>
    </div>
  )
}

export default Lockers
